var ResizeObserverDetail = (function () {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}());
export { ResizeObserverDetail };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@juggle/resize-observer/lib/ResizeObserverDetail.js
// module id = 718
// module chunks = 1